export default __webpack_public_path__ + "static/media/search-24.3d210d2f.svg";